import { IGenericResponse } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { useMutation } from 'react-query';
import { getHttpMethod } from '../../helpers';

const updateCreateInformation = async (variables: any): Promise<IGenericResponse> => {
  const resp = await apiRQ[getHttpMethod(variables?.id)]<IGenericResponse>('/admin/updates/', { data: variables });

  return resp.data;
};

export const useUpdateCreateUpdate = () => {
  return useMutation<IGenericResponse, Error>(updateCreateInformation);
};

const deleteUpdate = async (data: any): Promise<IGenericResponse> => {
  const resp = await apiRQ.delete<IGenericResponse>('/admin/updates/', { data });

  return resp.data;
};

export const useDeleteUpdate = () => {
  return useMutation<IGenericResponse, Error>(deleteUpdate);
};
